import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public darkMode = signal<boolean>(false);

  constructor() {
    const localStorageDarkMode = localStorage.getItem('dark-mode');
    if (localStorageDarkMode) {
      this.setDarkMode(localStorageDarkMode === 'true');
    }
    // TODO: Uncomment this code to enable automatic toggling of dark mode, for now we're making it opt-in
    // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    // this.setDarkMode(prefersDark.matches);
    //
    // prefersDark.addEventListener('change', e => {
    //   this.setDarkMode(e.matches);
    // });
  }

  setDarkMode(isDark: boolean) {
    this.darkMode.set(isDark);
    localStorage.setItem('dark-mode', isDark ? 'true' : 'false');
    if (isDark) {
      document.documentElement.setAttribute('data-color-mode', 'dark');
    } else {
      document.documentElement.setAttribute('data-color-mode', 'light');
    }
  }
}
